module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs web-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.webmasters')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/webmasters/analysis',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.web_analysis')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65da3394"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/WebTabs.vue
// module id = 567
// module chunks = 0